import React, { useState } from 'react';
import { Box, Typography, TextField, Select, MenuItem, FormControl, InputLabel, FormHelperText } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Nextstep } from './features/counterSlice';
import { updateResult } from './features/resultSlice';
import data from './data.json';
import { saveApiData } from './features/qustionSlice';
import axios from 'axios';

function Content1() {
  const dispatch = useDispatch();
const apiData = useSelector((state) => state.questionResult.apiData);
  console.log('apidata-contantpage', apiData);


 const [questiondata, setquestiondata] = useState({})
  const [formData, setFormData] = useState({
    name: '',
    class: '',
    school: ''
  });

  const [errors, setErrors] = useState({
    name: '',
    class: '',
    school: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));

    // Clear error when user types
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: ''
    }));
  };

  const handleClick = async () => {
  let hasError = false;
  let newErrors = { name: '', class: '', school: '' };

  if (!formData.name.trim()) {
    newErrors.name = 'Please enter your name.';
    hasError = true;
  }

  if (!formData.class) {
    newErrors.class = 'Please select your class.';
    hasError = true;
  }

  if (!formData.school.trim()) {
    newErrors.school = 'Please enter your school name.';
    hasError = true;
  }

  setErrors(newErrors);

  if (hasError) return;

  try {
    // Wait for Axios response before proceeding
    const response = await axios.post('https://demo.actify365.com/Api/GetData.php', formData);
     
    dispatch(saveApiData(response));
    console.log('siddharth data', response);
    dispatch(updateResult(formData));
    dispatch(Nextstep());

  } catch (err) {
    console.error('Error while sending data:', err);
  }
};


  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
        <Typography className="pertext" variant="h6">PRE-ASSESSMENT TEST</Typography>
      </Box>

      <Box display="flex" justifyContent="center" alignItems="center">
        <Box
          sx={{
            padding: 4,
            width: '100%',
            maxWidth: 400,
            borderRadius: 2,
            boxShadow: 3,
            textAlign: 'center',
            backgroundColor: '#fff',
          }}
        >
          <Box my={2}>
            <TextField
              fullWidth
              variant="outlined"
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="testInput"
              error={Boolean(errors.name)}
              helperText={errors.name}
              required
            />
          </Box>

          <Box my={2}>
            <FormControl fullWidth error={Boolean(errors.class)} required>
              <InputLabel id="class-select-label">Class</InputLabel>
              <Select
                labelId="class-select-label"
                id="class-select"
                name="class"
                value={formData.class}
                onChange={handleChange}
                className="testInput"
              >
                <MenuItem value="">Select Class</MenuItem>
                <MenuItem value="UKG">UKG</MenuItem>
                <MenuItem value="1">Class 1</MenuItem>
                <MenuItem value="2">Class 2</MenuItem>
                <MenuItem value="3">Class 3</MenuItem>
                <MenuItem value="4">Class 4</MenuItem>
                <MenuItem value="5">Class 5</MenuItem>
                <MenuItem value="6">Class 6</MenuItem>
              </Select>
              <FormHelperText>{errors.class}</FormHelperText>
            </FormControl>
          </Box>

          <Box my={2}>
            <TextField
              fullWidth
              variant="outlined"
              label="School Name"
              name="school"
              value={formData.school}
              onChange={handleChange}
              className="testInput"
              error={Boolean(errors.school)}
              helperText={errors.school}
              required
            />
          </Box>

          <Box mt={3}>
            <img
              src="/images/Picture7.png"
              alt="Play audio"
              style={{
                width: '150px',
                height: 'auto',
                objectFit: 'contain',
                cursor: 'pointer'
              }}
              onClick={handleClick}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default Content1;
